import { EntityService } from 'src/service/EntityService';

export class SignatureAssetService extends EntityService {

    static entity = 'iam-signature-assets';

    /**
     * Lấy danh sách chữ ký của người dùng hiện tại
     */
    static getPartySignatureAssets(): Promise<any> {
        return this.axios.get(`${this.entity}/list`).then(res => res.data);
    }

    /**
     * Tạo mới chữ ký (vẽ tay hoặc upload ảnh)
     * @param data { signatureName, signatureTypeEnumId, base64Data, isDefault }
     */
    static createSignatureAsset(data: any): Promise<any> {
        console.log(`POST to: ${this.entity}/create`);
        return this.axios.post(`${this.entity}/create`, data).then(res => res.data);
    }

    /**
     * Đặt chữ ký mặc định
     */
    static setDefaultSignatureAsset(signatureAssetId: string): Promise<any> {
        return this.axios.put(`${this.entity}/${signatureAssetId}/set-default`).then(res => res.data);
    }

    /**
     * Xóa chữ ký (Soft delete)
     */
    static deleteSignatureAsset(signatureAssetId: string): Promise<any> {
        return this.axios.delete(`${this.entity}/${signatureAssetId}`).then(res => res.data);
    }

    static updateSignatureAsset(signatureAssetId: string, data: any): Promise<any> {
        return this.axios.put(`${this.entity}/${signatureAssetId}`, data).then(res => res.data);
    }

    /**
     * Lấy cấu hình hiển thị chữ ký
     */
    static getSignatureDisplayConfig(signatureAssetId?: string): Promise<any> {
        const params = signatureAssetId ? { signatureAssetId } : {};
        return this.axios.get(`${this.entity}/display-config`, { params }).then(res => res.data);
    }

    /**
     * Tạo mới cấu hình hiển thị chữ ký
     */
    static createSignatureDisplayConfig(data: any): Promise<any> {
        return this.axios.post(`${this.entity}/display-config`, data).then(res => res.data);
    }

    /**
     * Cập nhật cấu hình hiển thị chữ ký
     */
    static updateSignatureDisplayConfig(displayConfigId: string, data: any): Promise<any> {
        return this.axios.put(`${this.entity}/display-config/${displayConfigId}`, data).then(res => res.data);
    }

    /**
     * Upload logo cho cấu hình hiển thị
     */
    static uploadLogo(base64Data: string): Promise<any> {
        return this.axios.post(`${this.entity}/display-config/upload-logo`, { base64Data }).then(res => res.data);
    }
}
